import { AuthenticateResponse, Account } from '../models';
import { urls } from '../utilities/dataHelpers';
import { mapAccountEntityToAccount } from '../utilities/mappers';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';
import { handleUserLoggedOut, handleUserRefresh } from './auth';

const handleUser = (request: MediatorRequestWithResponse<Account>) => {
  request.response = new Promise<Account>((resolve, reject) => {
    mediator
      .request<AuthenticateResponse>('api:invoke', {
        method: 'GET',
        url: urls.api + 'user',
      })
      .then((result) => {
        if (result.status === 200) {
          const response = result.data as AuthenticateResponse;

          if (response.user) {
            handleUserRefresh(response);

            resolve(mapAccountEntityToAccount(response.user));
          }

          reject(new Error('No user data found'));
        } else {
          handleUserLoggedOut();
          reject(result);
        }
      })
      .catch((err) => {
        handleUserLoggedOut();
        reject(err);
      });
  });
};

mediator.subscribe('user:getUser', handleUser);
